import { axios, axios2 } from '@/lib/axios';

import { ProfileResponse } from '../types';

export const getUser = (): Promise<ProfileResponse> => {
  // return axios2.get('customer-api/profile');
  return axios2.get('customer-api/complete-profile');
};
